
<template>
  <div class="padded">

    <equip-table
      title="Cabin / Outdoor"
      title-heading="h4"
      :site-id="this.siteId"
      :owner-id="this.ownerId"
      :site-data="siteData"
      :show-qr-code="showQrCode"
      filter-col="category"
      filter-val="Buildings" />

  </div>
</template>

<script>

import EquipTable from '@/components/assets/EquipTable'

export default {

  components: {
    EquipTable
  },

  props: {
    siteId: {
      type: [String, Number],
      required: true
    },

    siteData: {
      type: Object
    },

    ownerId: {
      type: [String, Number],
      default: null
    },

    showQrCode: {
      type: Boolean,
      default: false
    }
  }

}

</script>
